import React from "react";
import { User } from '../types/api';

interface UserSelectModalProps {
  open: boolean;
  onSelect: (user: User) => void;
  users: User[];
}

export default function UserSelectModal({ open, onSelect, users }: UserSelectModalProps) {
  const [selected, setSelected] = React.useState<string>("");

  React.useEffect(() => {
    setSelected("");
  }, [open, users]);

  if (!open) return null;
  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50">
      <div className="text-black bg-uiBackground rounded-lg p-8 min-w-[300px] shadow-lg">
        <h2 className="text-2xl font-bold">Select User</h2>
        <select
          value={selected}
          onChange={e => setSelected(e.target.value)}
          className="w-full p-3 rounded-md border border-black mt-4 mb-4 bg-white focus:outline-none focus:ring-2 focus:ring-primary-light dark:focus:ring-primary-dark cursor-pointer"
          onBlur={e => e.target.blur()}
        >
          <option value="" disabled>Select a user...</option>
          {users
            .filter(user => user?.userId && user?.username) // Only show users with valid data
            .map((user, index) => (
              <option
                key={user.userId}
                value={user.userId}
              >
                {user.username}
              </option>
            ))}
        </select>
        <button
          disabled={!selected}
          onClick={() => {
            const user = users.find(u => u.userId.toString() === selected);
            if (user) onSelect(user);
          }}
          className={`w-full px-4 py-2 rounded text-white font-semibold transition-colors duration-200 ${selected ? 'bg-primary-light dark:bg-primary-dark hover:bg-secondary-light dark:hover:bg-secondary-dark cursor-pointer' : 'bg-red-500 cursor-not-allowed'}`}
        >
          Confirm
        </button>
      </div>
    </div>
  );
}
